/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchCountList = {
    type: 'array',
    contains: {
        type: 'MatchCount',
    },
} as const;
